<template>
  <app-video :is-playing="isPlaying">
    <source :src="videoResource.src" :type="videoResource.type" />
  </app-video>
</template>

<script>
import AppVideo from '@/components/common/AppVideo.vue';

import { VIDEO_RESOURCE, RESPONSIVE_VIDEO_SIZE_MAP } from '@/constants/responsiveVideo';

import { getScreenSize } from '@/utils/common';

export default {
  name: 'ResponsiveVideo',
  components: { AppVideo },
  props: {
    videoResourceName: {
      type: String,
      required: true
    },
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const screenSize = getScreenSize();
    const screenSizeMapped = RESPONSIVE_VIDEO_SIZE_MAP[screenSize];

    return { screenSize: screenSizeMapped };
  },
  computed: {
    videoResource() {
      return VIDEO_RESOURCE[this.videoResourceName][this.screenSize];
    }
  }
};
</script>
